import React, {useEffect} from "react";
import { useParams } from "react-router-dom";
import {Card, Container, Row, Col} from 'react-bootstrap';

import { checkUserJwt, getUserByJwt } from "../common/api";

import LoadingComponent from "./LoadingComponent";

const DirectAuthorization = () => {

  const params = useParams();

  useEffect(() => {
    const checkJwt = async () => {
      try{
        const jwt = params.id;
        if (jwt) {

          

          const response = await checkUserJwt(jwt);
          if(Object.keys(response).length > 0 && response.data.uid !== undefined && response.data.uid > 0){
            const user = await getUserByJwt(jwt);
            if(user !== undefined && user.data !== undefined && user.data.data !== undefined && Object.keys(user.data.data).length > 0){
              let responseData = user.data.data;
              //console.log(responseData);
              
              if(responseData.status === "success" && responseData.token.length > 0 && Object.keys(responseData.data).length > 0){
                localStorage.setItem("jwt", responseData.token);
                localStorage.setItem("permissions", JSON.stringify(responseData.data.permissions));
                localStorage.setItem("uid", responseData.data.uid);
                localStorage.setItem("profile", JSON.stringify(responseData.data.profile));
                localStorage.setItem("expires", responseData.data.expires);

                const urlParams = new URLSearchParams(window.location.search);
                if(urlParams.size === 2){
                  const language = urlParams.get("language");
                  const slug = urlParams.get("slug");
                  window.location.href = "/single-book/"+language+"/"+slug;
                  return;
                }
          
                
                window.location.href = "/"
                
              }
            }
          }
          else{
            //window.location.href = "/";
          }
          //return;
        }
      }
      catch(err){
        console.log(err);
        //window.location.href = "/";
      }
    };
    checkJwt();
  })

  return(
    <React.Fragment>

      <Container>
        <Row className="justify-content-md-center">
          <Col md="auto">

            <Card>
              <Card.Body>
                <LoadingComponent />
                <h3>
                  Trwa uwierzytelnianie użytkownika
                </h3>
              </Card.Body>
            </Card>

          </Col>
        </Row>
      </Container>
      
    </React.Fragment>
  )

}
export default DirectAuthorization;